module.exports = __webpack_public_path__ + "img/location-pin-contact.083fdd9f.svg";